
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/sales-qualification",
      function () {
        return require("private-next-pages/integrations/sales-qualification.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/sales-qualification"])
      });
    }
  